import { render, staticRenderFns } from "./UpdateEmployee.vue?vue&type=template&id=2b42dd5f&scoped=true"
import script from "./UpdateEmployee.vue?vue&type=script&lang=js"
export * from "./UpdateEmployee.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmployee.vue?vue&type=style&index=0&id=2b42dd5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42dd5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b42dd5f')) {
      api.createRecord('2b42dd5f', component.options)
    } else {
      api.reload('2b42dd5f', component.options)
    }
    module.hot.accept("./UpdateEmployee.vue?vue&type=template&id=2b42dd5f&scoped=true", function () {
      api.rerender('2b42dd5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/UpdateEmployee.vue"
export default component.exports